module.exports = __webpack_public_path__ + "media/tone.7062d72f.mp3";